export const LOYALTY_PROGRAM_FILTER_VALUES = {
    UNSET: 'unset',
    ON: 'on',
    USER_OFF: 'user_off',
    AUTOMATIC_OFF: 'automatic_off',
};
export const getLoyaltyProgramFilterParams = ({ loyaltyProgramSelected, operatorLoyaltyProgram, }) => {
    if ((loyaltyProgramSelected === LOYALTY_PROGRAM_FILTER_VALUES.ON ||
        loyaltyProgramSelected === LOYALTY_PROGRAM_FILTER_VALUES.UNSET) &&
        operatorLoyaltyProgram) {
        return operatorLoyaltyProgram.searchFilters?.[0]?.queryParams || {};
    }
    return {};
};
